import { render } from "./gate.vue?vue&type=template&id=877fd66c&scoped=true"
import script from "./gate.vue?vue&type=script&lang=js"
export * from "./gate.vue?vue&type=script&lang=js"

import "./gate.vue?vue&type=style&index=0&id=877fd66c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877fd66c"]])

export default __exports__